import { Injectable } from '@angular/core';
import { Effect } from '@ngrx/effects';
import { DataPersistence } from '@nrwl/nx/src/nx.module';
import { from } from 'rxjs';
import { map ,  switchMap } from 'rxjs/operators';

import { fromCamelToDash } from '../../../../../helpers/';
import { GITHUB_COMPANY_PL } from '../../../../constants/';
import { GetCompleteAction } from '../../../../ngrx/actions/root.action';
import { AppState } from '../../../../ngrx/state';
import { jsonApiToEntityState } from '../../../../shared/services/app/web-socket/http-response';
import { AtlazApiV2Service } from '../../../../shared/services/atlaz-api/v2/atlaz-api-v2.service';
import { IntegrationNames } from '../../../core/integraition-list';
import * as integrations from '../../../core/store/integration.action';
import { removeByIdsFn } from '../../../settings/slack-alert/util/uninstall';
import { ESGithubCompany } from '../../models/git-company';
import * as githubCompany from './github-company.actions';
import * as fromGithubCompany from './github-company.reducer';

@Injectable()
export class GithubCompanyEffects {
  private key = fromCamelToDash(GITHUB_COMPANY_PL);

  defaultErrorHandler(action, error) {
    console.error('effect', action, error);
  }

  @Effect()
  getMany$ = this.data.fetch(githubCompany.GET_INDEX, {
    run: (action, store) =>
      this.api.get([this.key]).pipe(
        map(jsonApiToEntityState),
        switchMap((state: ESGithubCompany) => {
          let id;
          const actions: any[] = [
            new GetCompleteAction(state),
            new githubCompany.GetIndexComplete(state[GITHUB_COMPANY_PL])
          ];
          if ((id = this.getFirstId(state[GITHUB_COMPANY_PL]))) {
            actions.push(
              new integrations.IntegrationStatusUpdated({ name: IntegrationNames.Github, isInstalled: true })
            );
            actions.push(new githubCompany.SetActive(id));
          }

          return from(actions);
        })
      ),
    onError: this.defaultErrorHandler
  });

  @Effect()
  removeAll$ = this.data.pessimisticUpdate(githubCompany.REMOVE_ALL, {
    run: (action, store) => {
      const ids = fromGithubCompany.getIds(store);
      return this.remover(ids).pipe(
        switchMap(_ =>
          from([
            new githubCompany.RemoveAllComplete(),
            new integrations.IntegrationStatusUpdated({ name: IntegrationNames.Github, isInstalled: false })
          ])
        )
      );
    },
    onError: (action, error) => {
      this.defaultErrorHandler(action, error);
    }
  });

  constructor(private data: DataPersistence<AppState>, private api: AtlazApiV2Service) {}

  private remover = removeByIdsFn(this.api, this.key);

  private getFirstId(state: ESGithubCompany) {
    return state && state.ids[0];
  }
}
